import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '-0.5rem',
    marginBottom: '0.5rem',
    width: '100%',
    minHeight: '36px',
    maxHeight: '36px'
  },

  numSelected: {
    position: 'absolute',
    top: '50%',
    left: '0.5rem',
    transform: 'translateY(-50%)',
    fontSize: theme.size.sm,
    color: theme.palette.textLight
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    fontSize: theme.size.sm,
    gap: '1rem'
  },

  separator: {
    border: '1px solid #C6C6C6',
    height: '20px'
  },

  close: {
    position: 'absolute',
    top: '50%',
    right: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    transform: 'translateY(-50%)',
    cursor: 'pointer'
  }
}))

export default useStyles
